import { PropsWithChildren } from "react";
import useI18n from "../../hooks/useTranslations";
import SvgClose from "../icons/Close";
import styles from "./ControlledNumericWithQuantity.module.css";
import Icon from "./Icon";
import Input from "./Input";
import Numeric from "./Numeric";

interface ControlledNumericWithQuantityProps {
  item: {
    id: string;
    display: string;
    disabled?: boolean;
  };
  controls?: {
    scale?: number;
    disabled?: boolean;
  };
  quantity?: {
    quantity?: number;
    decimalScale?: number;
    disabled?: boolean;
    allowNegative?: boolean;
    onUpdate?: (id: string, quantity: number) => void;
    isInvalid?: boolean;
  };
  onDelete?: (id: string) => void;
}

const ControlledNumericWithQuantity = ({ item, controls, quantity, onDelete }: ControlledNumericWithQuantityProps) => {
  const i18n = useI18n();

  return (
    <div className={styles.item}>
      <Input value={item.display} disabled={!!item.disabled} />
      {!!quantity && (
        <Numeric
          min={0}
          width="50px"
          value={quantity.quantity ?? 0}
          allowNegative={quantity.allowNegative}
          isInvalid={quantity.isInvalid}
          decimalScale={quantity.decimalScale ?? 0}
          disabled={!!quantity?.disabled}
          onBlur={(value) => quantity.onUpdate?.(item.id, value ?? 0)}
          controls={
            controls
              ? {
                  scale: controls?.scale ?? 1,
                  onUpdate: (value) => quantity.onUpdate?.(item.id, value),
                }
              : undefined
          }
        />
      )}
      {!!onDelete && (
        <button
          type="button"
          title={i18n.translation.common.remove}
          className={styles.itemButton}
          disabled={!!controls?.disabled}
          onClick={(e) => {
            e.preventDefault();
            onDelete(item.id);
          }}
        >
          <Icon glyph={SvgClose} />
        </button>
      )}
    </div>
  );
};

const List = ({ children }: PropsWithChildren) => {
  return <div className={styles.items}>{children}</div>;
};

ControlledNumericWithQuantity.List = List;

export default ControlledNumericWithQuantity;
